import { Container } from '@algbra/ui/components/Grid/Grid'
import Icon from '@algbra/ui/components/Icon/Icon'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import {
  MEDIA_QUERY_MOBILE,
  useMediaQuery,
} from '@algbra/ui/hooks/useMediaQuery'
import { getIconByName } from '@algbra/ui/icons'
import { resolveAsImage } from '@algbra/ui/resolvers'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import Permalink from '@algbra/ui/components/Permalink/Permalink'
import React, { Fragment } from 'react'

import styles from './FeatureContainerBlock.module.scss'

export type ZoneFeatureContainerBlockProps = {
  __typename: 'StrapiGQL_ComponentZonesFeatureContainerBlock'
  backgroundImage: GatsbyResolvedAsset
  image?: GatsbyResolvedAsset
  description: string
  featureContainerTitle: string
  detailLinkText?: string
  detailLink?: string
  featureContainerTheme?: 'black' | 'white'
}

export default function ZoneFeatureContainerBlock(
  props: ZoneFeatureContainerBlockProps
) {
  const {
    backgroundImage,
    image,
    description,
    featureContainerTitle,
    detailLinkText,
    detailLink,
    featureContainerTheme = 'black',
  } = props
  const isMobile = useMediaQuery(MEDIA_QUERY_MOBILE)
  const BoxDetailLink = props => {
    return (
      <FreeText
        className={classNames(
          [styles.boxDetailLink, props.className],
          [styles[props.theme], props.theme]
        )}
        color={props.linkColor}
      >
        <Permalink className={styles.linkText} to={props.linkUrl} isBlank isExternal>
          {props.linkText}
        </Permalink>
        <Icon
          icon={getIconByName('arrow-right')}
          size={24}
          className={styles.arrow}
        />
      </FreeText>
    )
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.noImage]: !image,
      })}
      style={{
        backgroundImage: `url(${backgroundImage.resolved.publicURL})`,
      }}
    >
      <Container className={styles.container}>
        <div className={styles.contentWrapper}>
          <div
            className={classNames(styles.contentContainer, {
              [styles.hasImage]: image,
            })}
          >
            <Heading
              type="xl"
              className={classNames(styles.title, {
                [styles.white]: featureContainerTheme === 'white',
              })}
              dangerouslySetInnerHTML={{ __html: featureContainerTitle }}
            ></Heading>
            <FreeText
              type="md"
              innerHTML={description}
              className={classNames(styles.description, {
                [styles.white]: featureContainerTheme === 'white',
              })}
            >
              {description}
            </FreeText>
            {detailLink && detailLinkText && (
              <BoxDetailLink
                linkColor={featureContainerTheme}
                linkUrl={detailLink}
                linkText={detailLinkText}
                theme={featureContainerTheme}
              />
            )}
          </div>
          {!!image && (
            <GatsbyImage
              image={resolveAsImage(image)}
              alt={featureContainerTitle}
              className={styles.image}
              loading="lazy"
            />
          )}
        </div>
      </Container>
    </div>
  )
}
